import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaRemuneracaoADMRH: ['referencia'],
    setMatriculaConsultaRemuneracaoADMRH: ['matricula'],
    setCargoConsultaRemuneracaoADMRH: ['cargo'],
    limpaFiltroConsultaRemuneracaoADMRH: [],
    receberFiltroConsultaRemuneracaoADMRH: ['filtroRecebido'],
    setStatusConsultaRemuneracaoADMRH: ['status'],
})

const INITIAL_STATE = {
    cargo: '',
    referencia: '',
    matricula: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const setMatricula = (state = INITIAL_STATE, action) => {
    return { ...state, matricula: action.matricula }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_REMUNERACAO_ADMRH]: setReferencia,
    [Types.SET_MATRICULA_CONSULTA_REMUNERACAO_ADMRH]: setMatricula,
    [Types.SET_CARGO_CONSULTA_REMUNERACAO_ADMRH]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_REMUNERACAO_ADMRH]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_REMUNERACAO_ADMRH]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_REMUNERACAO_ADMRH]: setStatus,
})
